import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//

import store from './store';
export default {
  name: 'App',
  watch: {
    '$route': function $route(newRoute) {
      console.log(newRoute);
      var noCheckRoutes = ['/overview/index', '/login', '/openRonglian'];
      if (newRoute.path && !noCheckRoutes.includes(newRoute.path)) {
        if (!store.getters.sellUsersList.length) {
          store.dispatch('user/getSellUsers');
        }
        if (!store.getters.companyList.length) {
          store.dispatch('user/getCompanyList');
        }
      }
    }
  }
};